import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue";
const _hoisted_1 = {
  class: "SchoolListViewContainer"
};
const _hoisted_2 = {
  class: "bothCenter"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "leftCenter"
};
const _hoisted_6 = ["onClick"];
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "ptr"
};
const _hoisted_9 = {
  class: "leftCenter"
};
const _hoisted_10 = {
  key: 0,
  src: "https://cdn.waityou.online/736652c6-a95c-f436-1dc5-4b44507142ca.png",
  class: "sqr16 mr6"
};
const _hoisted_11 = {
  key: 1,
  src: "https://cdn.waityou.online/53543ff1-c94a-8357-9be6-3cbdcf9315b9.png",
  class: "sqr16 mr6"
};
const _hoisted_12 = {
  key: 2,
  src: "https://cdn.waityou.online/f20f781c-4f06-dd03-eb6d-645acc31629d.svg",
  class: "sqr16 mr6"
};
const _hoisted_13 = {
  class: "leftCenter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_text = _resolveComponent("el-text");
  const _component_BatterTableDataView = _resolveComponent("BatterTableDataView");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_tabs, {
    modelValue: $data.tab,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.tab = $event)
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.sites, site => {
      return _openBlock(), _createBlock(_component_el_tab_pane, {
        key: `site_${site.value}`,
        label: site.label,
        name: site.label
      }, {
        default: _withCtx(() => [_createVNode(_component_BatterTableDataView, {
          "table-id": 10,
          "init-query": {
            siteId: site.value
          },
          ref_for: true,
          ref: "schools"
        }, {
          recommendPageId: _withCtx(data => [_createElementVNode("div", _hoisted_2, [data.data.recommendPage ? (_openBlock(), _createBlock(_component_el_text, {
            key: 0,
            truncated: "",
            class: "ptr",
            style: {
              "color": "#009FFF",
              "max-width": "100px"
            },
            onClick: $event => $options.previewHtml(data.data.recommendPage)
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(data.data.recommendPage.title), 1)]),
            _: 2
          }, 1032, ["onClick"])) : _createCommentVNode("", true), !data.rowData ? (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: "https://cdn.waityou.online/3add728e-a2d8-6ca4-5a06-2afb4d4d2465.svg",
            onClick: $event => $options.addPage(data.rowId, site.value),
            class: "sqr20 ml12 ptr"
          }, null, 8, _hoisted_3)) : (_openBlock(), _createElementBlock("img", {
            key: 2,
            src: "https://cdn.waityou.online/d9c59ce2-3fd9-f521-3ead-b5fd0baba038.svg",
            onClick: $event => $options.addPage(data.rowId, site.value),
            class: "sqr20 ml12 ptr"
          }, null, 8, _hoisted_4))])]),
          schoolName: _withCtx(data => [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", {
            style: {
              "color": "#009FFF"
            },
            onClick: $event => $options.goToEditSchoolContent(data.data),
            class: "ptr"
          }, _toDisplayString(data.rowData), 9, _hoisted_6), _createElementVNode("img", {
            src: data.data.schoolIcon,
            class: "sqr40 ml12"
          }, null, 8, _hoisted_7)])]),
          schoolTagNames: _withCtx(data => [_createElementVNode("span", _hoisted_8, _toDisplayString(data.rowData.join('、')), 1)]),
          _: 2
        }, 1032, ["init-query"])]),
        _: 2
      }, 1032, ["label", "name"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue"])]), _createVNode(_component_DialogCustomView, {
    width: "1200px",
    title: "绑定学校推荐文章",
    "visible-control": $data.addPageVisible
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      type: "danger",
      size: "small",
      class: "mb12",
      onClick: _cache[1] || (_cache[1] = $event => $options.choose(null))
    }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("移除推荐文章")])),
      _: 1
    }), _createVNode(_component_BatterTableDataView, {
      "table-id": 12,
      "init-query": {
        addBtn: false,
        siteId: $data.siteId,
        refId: $data.siteId
      }
    }, {
      nav: _withCtx(data => [_createElementVNode("div", _hoisted_9, [data.data.hotSearchTag == 'HOT' ? (_openBlock(), _createElementBlock("img", _hoisted_10)) : _createCommentVNode("", true), data.data.hotSearchTag == 'NEW' ? (_openBlock(), _createElementBlock("img", _hoisted_11)) : _createCommentVNode("", true), data.data.hotSearchTag == 'NONE' ? (_openBlock(), _createElementBlock("img", _hoisted_12)) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(data?.data?.nav?.label) + " / " + _toDisplayString(data?.data?.subNav?.label), 1)])]),
      title: _withCtx(data => [_createElementVNode("div", _hoisted_13, [data.data.schoolId != null ? (_openBlock(), _createBlock(_component_el_tooltip, {
        key: 0,
        class: "item",
        effect: "dark",
        content: data.data.schoolName,
        placement: "top"
      }, {
        default: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("img", {
          src: "https://cdn.waityou.online/439a2635-e911-3559-3581-b16eb0f557e0.svg",
          class: "sqr16 mr12"
        }, null, -1)])),
        _: 2
      }, 1032, ["content"])) : _createCommentVNode("", true), _createElementVNode("span", null, _toDisplayString(data.rowData), 1)])]),
      operate: _withCtx(data => [_createVNode(_component_el_button, {
        onClick: $event => $options.choose(data.rowId)
      }, {
        default: _withCtx(() => _cache[4] || (_cache[4] = [_createTextVNode("选择")])),
        _: 2
      }, 1032, ["onClick"])]),
      _: 1
    }, 8, ["init-query"])]),
    _: 1
  }, 8, ["visible-control"])], 64);
}